import React from 'react';
var VeltAutocomplete = function (props) {
    var hotkey = props.hotkey, listData = props.listData;
    return (React.createElement("velt-autocomplete", { hotkey: hotkey, "list-data": (typeof listData === 'object') ? JSON.stringify(listData) : undefined }));
};
export default VeltAutocomplete;
